export const baseUrl = process.env.REACT_APP_URL;
// Central auth (SynapseAuth) root — auth routes call this DIRECTLY (absolute
// URLs in authApi bypass the RTK baseUrl). No path suffix.
export const authBaseUrl = process.env.REACT_APP_AUTH_URL;

export const validation = {
  emailMax: 100,
  passwordMin: 8,
  passwordMax: 20,
  nameMin: 3,
  nameMax: 50,
  longNameMin: 3,
  longNameMax: 200,
  descriptionMax: 255,
  otpCodeMin: 4,
  otpCodeMax: 4,
  positionMin: 5,
  positionMax: 50,
  searchMax: 20,
};

export const validationText = {};

export const localStorageConstant = {
  tokenKey: 'project_name_token',
  tempTokenKey: 'project_name_temp_token', // now holds the reset challenge_token
  refreshKey: 'project_name_refresh_token',
  userKey: 'project_name_user',
};

// export const firebaseConfig = {
//     apiKey:process.env.VITE_FIREBASE_API_KEY,
//     authDomain:process.env.VITE_FRIREBASE_AUTH_DOMAIN,
//     projectId:process.env.VITE_FIREBASE_PROJECT_ID,
//     storageBucket:process.env.VITE_STORAGE_BUCKET,
//     messagingSenderId:process.env.VITE_MESSAGING_SENDER_ID,
//     appId:process.env.VITE_FIREBASE_APP_ID
// }

export const apiUrls = {
  // auth
  signin: '/auth/login',
  forgotPassword: '/auth/forgot-password',
  verifyOtp: '/auth/verify-otp',
  changePassword: '/auth/change-password',
  signout: '/auth/logout',
  getMyProfile: '/user/profile',

  // user
  user: '/admin/user',
  getAllUsers: '/admin/users',
  userStatus: '/admin/user/status',
  getAllGroups: '/admin/user/groups',
  getAllChats: '/admin/user/chats',
  getAllThreads: '/admin/user/groups',
  downloadChat: '/admin/user-chat/download',
  userResetPassword: '/admin/user/reset-password',
  sendOtp: '/admin/user/send-otp',
  // Sessions are read directly from central auth (GET {AUTH}/v1/admin/sessions),
  // see store/apis/userApi.js — no Synapse-backend session URLs.

  // company
  company: '/admin/company',
  getAllCompanies: '/admin/companies',
  getCompaniesList: '/admin/companies/list',
  companyStatus: '/admin/company/status',

  // brands (central-auth brands, proxied via the Synapse backend)
  brands: '/admin/brands',
  getAllGroupChats: '',
  downloadGroupChat: '/admin/chat/download',
  groupMessages: '/admin/channel',
  companyDetails: '/admin/company/details',

  // report
  getAllMessageReport: '/admin/chat/reports',
  getAllUserReport: '/admin/users/reports',
  deleteReportedMessage: '/admin/reports',

  // dashboard
  getDashboardData: '/admin/getDashboardCount',

  // settings
  subAdmin: '/admin/settings/sub-admin',
  subAdminPic: '/admin/settings/sub-admin-pic',

  // support
  supportList: '/admin/global-search',
  getChatById: '/chat/channel',
  deleteSupportRequest: '/admin/support-message/delete',

  // Chat Management
  usersChatsRequest: '/admin/chats/all',
  usersGroupsRequest: '/admin/groups/all',
};

//links for qa
// export const link = {
//   default: "/admin/",
//   otpVerification: "/admin/otp-verification",
//   resetPassword: "/admin/reset-password",
//   forgotPassword: "/admin/forgot-password",
//   dashboard: "/admin/dashboard",
//   userManagement: "/admin/user-management",
//   reportManagement: "/admin/report-management",
//   companyManagement: "/admin/company-management",
//   contactSupport: "/admin/contact-support",
//   settings: "/admin/settings",
//   subAdminManagement: "/admin/settings",
//   changePassword: "/admin/change-password",
//   userDetail: "/admin/user-detail",
//   companyDetail: "/admin/company-detail",
//   chatManagement: "/admin/chat-management",
//   sessionIntelligence: "/admin/session-intelligence",
//   userSessions: "/admin/user-sessions",
// };

// links for live

export const link = {
  default: '/',
  otpVerification: '/otp-verification',
  resetPassword: '/reset-password',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  userManagement: '/user-management',
  reportManagement: '/report-management',
  companyManagement: '/company-management',
  // Unified admin (central-auth orchestrated) — one brand spans Synapse + LiveChat.
  unifiedBrands: '/unified-brands',
  unifiedUsers: '/unified-users',
  roles: '/roles',
  contactSupport: '/contact-support',
  settings: '/settings',
  subAdminManagement: '/settings',
  changePassword: '/change-password',
  userDetail: '/user-detail',
  companyDetail: '/company-detail',
  chatManagement: '/chat-management',
  sessionIntelligence: '/session-intelligence',
  userSessions: '/user-sessions',
  livechatTickets: '/livechat/tickets',
  livechatSessions: '/livechat/sessions',
  livechatAuditLogs: '/livechat/audit-logs',
  livechatContacts: '/livechat/contacts',
};

export const platform = {
  admin: 'ADMIN',
};

export const levels = [
  {
    label: 'Level 1',
    value: 'LEVEL1',
  },
  {
    label: 'Level 2',
    value: 'LEVEL2',
  },
  {
    label: 'Level 3',
    value: 'LEVEL3',
  },
];

export const userStatus = {
  active: 'Active',
  suspended: 'Suspended',
};

export const msgListType = {
  group: 'GROUP',
  thread: 'THREAD',
};

export const companyDetailType = {
  group: 'GROUP',
  profile: 'PROFILE',
};

export const messageTypes = {
  text: 'TEXT',
  media: 'MEDIA',
};

export const mediaFormat = {
  image: 'image/jpeg',
};

export const acceptedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];

export const MAX_IMAGE_SIZE = 20 * 1024 * 1024;

export const MESSAGE_LIMIT = 150;

export const actionType = {
  delete: 'delete',
  block: 'block',
};

export const rtkTagTypes = [
  'users',
  'company',
  'groups',
  'chats',
  'threads',
  'groupChats',
  'participants',
  'messageReports',
  'userReports',
  'supportRequests',
  'dashboardData',
  'subAdmins',
  'activeSessions',
  'brand',
  'brandGroups',
  'authUsers',
  'authRoles',
];

export const limit = 8;

export const msgLimit = 5;

export const reportLimit = 6;

export const widgetBaseUrl = process.env.REACT_APP_WIDGET_API_URL;
export const livechatBaseUrl = process.env.REACT_APP_LIVECHAT_API_URL;
export const livechatSocketUrl = process.env.REACT_APP_LIVECHAT_SOCKET_URL;

export const livechatApiUrls = {
  brands: '/v1/brands',
  brandStatus: '/v1/brands/:id/status',
  sessions: '/v1/sessions',
  tickets: '/v1/tickets',
  messages: '/v1/messages',
  reviews: '/v1/reviews',
  miscUpload: '/v1/misc/upload',
  botQuestions: '/v1/questions',
  agents: '/v1/agents',
  roles: '/v1/roles',
  auditLogs: '/v1/audit-logs',
  contacts: '/v1/contact',
};

export const livechatLimit = 10;

export const DEFAULT_LIVECHAT_BRAND_ID = '00000000-0000-0000-0000-000000000001';
